import { render, staticRenderFns } from "./NprogressContainer.vue?vue&type=template&id=ff610604&"
import script from "./NprogressContainer.vue?vue&type=script&lang=js&"
export * from "./NprogressContainer.vue?vue&type=script&lang=js&"
import style0 from "./NprogressContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ff610604', component.options)
    } else {
      api.reload('ff610604', component.options)
    }
    module.hot.accept("./NprogressContainer.vue?vue&type=template&id=ff610604&", function () {
      api.rerender('ff610604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/NprogressContainer.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/NprogressContainer.vue
// module id = 7NZE
// module chunks = 0